module.exports = __webpack_public_path__ + "img/18.8d18c180.png";